/**
 * Safely navigates the top-level frame to the given URL.
 *
 * When the app runs inside a cross-origin iframe (e.g. on iOS/Safari),
 * assigning to window.top.location.href throws a SecurityError (DOMException
 * code 18). In that case we fall back to navigating the current frame instead.
 */
export function navigateTopSafely(url: string): void {
  try {
    (window.top ?? window).location.href = url;
  } catch {
    // SecurityError: cross-origin iframe restriction (e.g. iOS/Safari)
    window.location.href = url;
  }
}
